import { readZendeskSupportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { HelpRepositoryInterface } from "../repositories/help-repository-interface";
import { ZendeskContactUrlBuilder } from "../builders/zendesk-contact-url-builder";
import { OnboardingSupportEmailBuilder } from "../builders/onboarding-support-email-builder";
import { SupportEmailContext } from "./user-info";

export class Help {
  private repository: HelpRepositoryInterface;

  constructor(repository: HelpRepositoryInterface) {
    this.repository = repository;
  }

  getFaqUrl(): string {
    return this.repository.getFaqUrl();
  }

  getContactUrl(): string {
    const userInfo = this.repository.getUserInfo();
    return new ZendeskContactUrlBuilder(
      readZendeskSupportUrlEnvVar(),
    ).buildContactUrl(userInfo);
  }

  getContactUrlForFailedGatewayOnboarding(
    sourceDsn: string,
    connectionId?: string,
    context?: SupportEmailContext,
  ): string {
    const userInfo = this.repository.getUserInfo();
    return new OnboardingSupportEmailBuilder().buildGatewaySupportEmail(
      userInfo,
      sourceDsn,
      connectionId,
      {
        ...context,
        namespaceId: context?.namespaceId?.trim() || userInfo.namespace?.trim(),
      },
    );
  }

  getContactUrlForMachineOnboarding(context: SupportEmailContext): string {
    const userInfo = this.repository.getUserInfo();
    return new OnboardingSupportEmailBuilder().buildMachineSupportEmail(
      userInfo,
      {
        ...context,
        namespaceId: context.namespaceId?.trim() || userInfo.namespace?.trim(),
      },
    );
  }

  getContactUrlForFailedForFailedSourceConnection(
    sourceDsn: string,
    gatewayUuid: string,
    connectionId?: string,
  ): string {
    const userInfo = this.repository.getUserInfo();

    return new ZendeskContactUrlBuilder(
      readZendeskSupportUrlEnvVar(),
    ).buildContactUrlForFailedSourceConnection(
      userInfo,
      sourceDsn,
      gatewayUuid,
      connectionId,
    );
  }

  getBlueprintHelpRequestUrl(): string {
    const userInfo = this.repository.getUserInfo();
    const sourceInfo = this.repository.getSourceInfo();

    return new ZendeskContactUrlBuilder(
      readZendeskSupportUrlEnvVar(),
    ).buildBlueprintHelpRequestUrl(userInfo, sourceInfo);
  }
}
